/**
 * Standard Microsoft 4-square brand icon.
 * Uses the official Microsoft brand colors (red, green, blue, yellow).
 * Decorative; pair with descriptive text or `aria-label` on the parent.
 */
interface MicrosoftIconProps {
  /** Icon size in pixels (square). */
  size?: number;
  /** Accessible label. When omitted, the icon is rendered as decorative. */
  title?: string;
}

/**
 * Renders the four-square Microsoft logo as inline SVG.
 */
export function MicrosoftIcon({ size = 18, title }: MicrosoftIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      aria-label={title}
    >
      <rect x="1" y="1" width="9" height="9" fill="#f25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
      <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
      <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
    </svg>
  );
}
